export interface ComboChunkFilter {
    offSet?: number;
    pageSize?: number;
    filterValue?: string;
}

export function getComboFilteredChunk<T>(
    items: T[],
    getText: (item: T) => string,
    { offSet = 0, pageSize = 50, filterValue = "" }: ComboChunkFilter
) {
    const normalizedFilter = String(filterValue ?? "").trim().toLowerCase();
    const filteredItems = !normalizedFilter
        ? items
        : items.filter((item) => getText(item).toLowerCase().includes(normalizedFilter));

    return filteredItems.slice(offSet, offSet + pageSize);
}
